export const createJumpSlice = (set) => ({
    jumpForward: 10,
    jumpBackward: 10,
    setJumpForward: (jumpForward) => set(() => ({ jumpForward })),
    setJumpBackward: (jumpBackward) => set(() => ({ jumpBackward })),
});
//# sourceMappingURL=jump.js.map